import { FiSun, FiMoon } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext.jsx';

/**
 * ThemeToggle
 * Self-contained light/dark switch. Drop it anywhere — it reads/writes
 * theme state via useTheme() (see src/context/ThemeContext.jsx), so no
 * props are required. Pass `className` to adjust sizing/spacing for the
 * spot you're placing it in (navbar, mobile drawer, footer, etc).
 */
const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <motion.button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      whileTap={{ scale: 0.9 }}
      className={`w-9 h-9 flex items-center justify-center rounded-full bg-nav-surface text-nav-text hover:text-white hover:bg-white/10 transition-colors ${className}`}
    >
      {isDark ? <FiSun className="text-sm" /> : <FiMoon className="text-sm" />}
    </motion.button>
  );
};

export default ThemeToggle;
